import React from 'react';

export const SourceTypeVectorUDT = (props: { size: number } = { size: 24 }) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="new-Icon/source_vectorUDT"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect
        id="bck-SorceDataType"
        fill="#575757"
        x="0"
        y="0"
        width="32"
        height="32"
        rx="2"
      ></rect>
      <g
        id="VEC"
        transform="translate(3.500000, 8.000000)"
        fill="#FFFFFF"
        fill-rule="nonzero"
      >
        <polygon
          id="Path"
          points="8.3846831 0.132042254 5.17165493 15.8010563 3.19102113 15.8010563 0 0.132042254 2.37676056 0.132042254 4.15933099 11.0695423 4.20334507 11.0695423 6.00792254 0.132042254"
        ></polygon>
        <polygon
          id="Path"
          points="9.72711268 15.8010563 9.72711268 0.132042254 16.4172535 0.132042254 16.4172535 2.24471831 11.971831 2.24471831 11.971831 6.84419014 15.8450704 6.84419014 15.8450704 8.9568662 11.971831 8.9568662 11.971831 13.556338 16.4172535 13.556338 16.4172535 15.8010563"
        ></polygon>
        <path
          d="M25,11.3336268 L25,12.3019366 C25,12.7860915 24.908304,13.2445716 24.724912,13.6773768 C24.54152,14.1101819 24.288439,14.4953052 23.965669,14.8327465 C23.6428991,15.1701878 23.2651115,15.4379401 22.8323063,15.6360035 C22.3995012,15.8340669 21.9336854,15.9330986 21.4348592,15.9330986 C21.0093897,15.9330986 20.5765845,15.8744131 20.1364437,15.7570423 C19.6963028,15.6396714 19.3001761,15.4342723 18.9480634,15.1408451 C18.5959507,14.8474178 18.3061913,14.4696303 18.0787852,14.0074824 C17.8513791,13.5453345 17.7376761,12.9548122 17.7376761,12.2359155 L17.7376761,3.60915493 C17.7376761,3.09565728 17.8257042,2.61883803 18.0017606,2.17869718 C18.1778169,1.73855634 18.42723,1.35710094 18.75,1.03433099 C19.07277,0.711561033 19.4578932,0.458480047 19.9053697,0.275088028 C20.3528462,0.0916960094 20.8480047,0 21.3908451,0 C22.4471831,0 23.3054577,0.344776995 23.965669,1.03433099 C24.288439,1.3717723 24.54152,1.7715669 24.724912,2.23371479 C24.908304,2.69586268 25,3.19835681 25,3.74119718 L25,4.62147887 L22.7552817,4.62147887 L22.7552817,3.87323944 C22.7552817,3.43309859 22.6305751,3.05164319 22.381162,2.72887324 C22.1317488,2.40610329 21.7943075,2.24471831 21.368838,2.24471831 C20.8113263,2.24471831 20.4408744,2.41710681 20.2574824,2.7618838 C20.0740904,3.1066608 19.9823944,3.5431338 19.9823944,4.07130282 L19.9823944,12.0818662 C19.9823944,12.5366784 20.0814261,12.9181338 20.2794894,13.2262324 C20.4775528,13.534331 20.8333333,13.6883803 21.346831,13.6883803 C21.4935446,13.6883803 21.6512617,13.6627054 21.8199824,13.6113556 C21.9887031,13.5600059 22.1464202,13.4756455 22.2931338,13.3582746 C22.4251761,13.2409038 22.5352113,13.0795188 22.6232394,12.8741197 C22.7112676,12.6687207 22.7552817,12.4119718 22.7552817,12.1038732 L22.7552817,11.3336268 L25,11.3336268 Z"
          id="Path"
        ></path>
      </g>
    </g>
  </svg>
);
